/* eslint-disable react/no-array-index-key */
import React from "react";
import ModalCommon from "components/ModalCommon";
import * as S from "./styles";
import { FundoIcon } from "./fundoIcon";

interface InternshipExpirationModalProps {
  daysRemaining: number;
  open: boolean;
  setOpen: (value: boolean) => void;
  userName?: string;
}

const InternshipExpirationModal: React.FC<InternshipExpirationModalProps> = ({
  daysRemaining,
  open,
  setOpen,
  userName = "Usuário",
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const getContent = () => {
    const isUrgent = daysRemaining <= 3;
    const isUrgentText = daysRemaining === 0;

    let title = "";
    let message = "";

    if (daysRemaining === 15) {
      title = `Seu Estágio está perto de vencer!`;
      message = `Olá ${userName}! Notamos que sua Carteira de Estágio vence em ${daysRemaining} dias.\n\nSe programe para regularizar sua carteirinha junto ao CRECI.`;
    } else if (daysRemaining === 10) {
      title = `Atenção: ${daysRemaining} dias para o vencimento do seu Estágio!`;
      message = `Sua Carteira de Estágio está próxima de vencer.\n\nFaltam ${daysRemaining} dias para a data de expiração.\n\nSe planeje para regularizar sua carteirinha no CRECI.`;
    } else if (daysRemaining === 5) {
      title = `Atenção: Vencimento do Estágio em ${daysRemaining} dias!`;
      message = `Sua Carteira de Estágio expirará em ${daysRemaining} dias.\n\nVocê já verificou como regularizar sua carteirinha no CRECI?`;
    } else if (daysRemaining === 3) {
      title = `Últimos dias de validade do seu Estágio!`;
      message = `Faltam ${daysRemaining} dias para o vencimento da sua Carteira de Estágio. Regularize seu documento junto ao CRECI para manter seus acessos nos sistemas.`;
    } else if (daysRemaining === 0) {
      title = `Seu Estágio vence hoje!`;
      message = `Hoje é o último dia de validade do seu Estágio.\n\nA partir de amanhã, o acesso ao sistema será bloqueado até que tenha a nova carteirinha com validade vigente.`;
    } else {
      title = ``;
      message = ``;
    }

    return { title, message, isUrgent, isUrgentText };
  };

  const { title, message, isUrgent, isUrgentText } = getContent();

  const messageLines = message.split("\n");

  return (
    <ModalCommon open={open} onClose={handleClose} setOpenModal={setOpen}>
      <S.Content>
        <S.IconContainer>
          <FundoIcon isUrgent={isUrgent} />
        </S.IconContainer>

        <S.Title isUrgent={isUrgent} isUrgentText={isUrgentText}>
          {title}
        </S.Title>

        <S.Message>
          {messageLines.map((line, index) => (
            <span
              key={index}
              dangerouslySetInnerHTML={{
                __html: line.replace(
                  /(\d+) dias/,
                  "<strong style='color: #333333;'>$1 dias</strong>"
                ),
              }}
            />
          ))}
        </S.Message>

        <S.ButtonContainer>
          <S.UnderstandButton onClick={handleClose}>Entendi</S.UnderstandButton>
        </S.ButtonContainer>
      </S.Content>
    </ModalCommon>
  );
};

export default InternshipExpirationModal;
